// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-6784181e]:export{menuBg:#414146;menuText:#e0e3da;menuActiveText:#fffff3}.ed-header__container[data-v-6784181e]{display:flex;justify-content:space-between}.ed-header__container .left[data-v-6784181e],.ed-header__container .right[data-v-6784181e]{display:flex;align-items:center}.ed-header__container .search-input[data-v-6784181e]{width:240px;margin-right:10px}", ""]);
// Exports
module.exports = exports;
